(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-sh-art-poster-index]';
  var STORAGE_KEY = 'shArtPosterIndexSaved';
  var ALLOWED_MULTI_PRODUCT_GROUPS = new Set();
  var FAMILY_TITLES = {};
  var FAMILY_ORDER = {};

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (root.dataset.shInitialized === 'true') return;
      root.dataset.shInitialized = 'true';
      init(root);
    });
  }

  function init(root) {
    var dataNode = root.querySelector('[data-sh-product-data]');
    if (!dataNode) return;

    var products;
    try {
      products = JSON.parse(dataNode.textContent || '[]');
    } catch (error) {
      console.error('SickHaus Poster Index collection data could not be read.', error);
      return;
    }

    var variantImageOverrides = readVariantImageOverrides();

    products = products.filter(function (product) {
      return product && product.handle;
    }).map(normalizeProduct);

    var currency = root.dataset.currency || 'GBP';
    var locale = root.dataset.locale || document.documentElement.lang || navigator.language || 'en';
    var country = root.dataset.country || '';
    if (locale.indexOf('-') === -1 && country) locale += '-' + country;
    var collectionUrl = root.dataset.collectionUrl || window.location.pathname;
    var initialLimit = Math.max(8, Number(root.dataset.initialLimit || 24));
    var loadIncrement = Math.max(4, Number(root.dataset.loadIncrement || 12));
    var priceRanges = readPriceRanges();
    var grid = root.querySelector('[data-sh-product-grid]');
    var applied = root.querySelector('[data-sh-applied-filters]');
    var resultsCount = root.querySelector('[data-sh-results-count]');
    var filterCount = root.querySelector('[data-sh-filter-count]');
    var sortSelect = root.querySelector('[data-sh-sort]');
    var filterDrawer = root.querySelector('[data-sh-filter-drawer]');
    var filterBackdrop = root.querySelector('[data-sh-filter-backdrop]');
    var modal = root.querySelector('[data-sh-quick-modal]');
    var modalBackdrop = root.querySelector('[data-sh-modal-backdrop]');
    var toast = root.querySelector('[data-sh-toast]');
    var loadWrap = root.querySelector('[data-sh-load-wrap]');
    var loadButton = root.querySelector('[data-sh-load-more]');
    var loadNote = root.querySelector('[data-sh-load-note]');
    var copy = readCopy();
    var selectedByGroup = Object.create(null);
    var preferredVariantByProduct = Object.create(null);
    var saved = readSaved();
    var imagePromises = new Map();
    var switchSequence = 0;
    var stickyFrame = null;
    var lastFocus = null;
    var activeModalGroup = null;
    var activeModalProduct = null;
    var activeVariant = null;

    var nextDataPage = dataNode.dataset.shNextPage || '';
    var collectionRequest = null;
    async function ensureCollectionComplete() {
      if (!nextDataPage) return;
      if (collectionRequest) return collectionRequest;
      root.setAttribute('aria-busy', 'true');
      collectionRequest = (async function () {
        var visited = new Set();
        while (nextDataPage) {
          if (visited.has(nextDataPage)) throw new Error("Repeated collection page");
          visited.add(nextDataPage);
          var url = new URL(nextDataPage, location.origin);
          url.searchParams.set('section_id', dataNode.dataset.shSectionId);
          var response = await fetch(url.href, {credentials: 'same-origin'});
          if (!response.ok) throw new Error('Collection request failed');
          var parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          var nextNode = parsed.querySelector('[data-sh-product-data]');
          if (!nextNode) throw new Error('Collection data missing');
          var incoming = JSON.parse(nextNode.textContent || '[]');
          var known = new Set(products.map(function (product) { return product.handle; }));
          incoming.filter(function (product) {
            if (!product || !product.handle || known.has(product.handle)) return false;
            return true;
          }).forEach(function (product) {
            product.manualOrder = products.length + 1;
            products.push(normalizeProduct(product));
          });
          nextDataPage = nextNode.dataset.shNextPage || '';
        }
        groups = groupProducts(products);
        populateFilters();
        updateViewCounts();
        syncFilterControls();
        render(false);
      }()).finally(function () { collectionRequest = null; root.removeAttribute('aria-busy'); });
      return collectionRequest;
    }

    var groups = groupProducts(products);
    var state = readStateFromUrl();
    if (sortSelect) sortSelect.value = state.sort;

    var filterDefinitions = {
      categories: [
        ['Japanese & Retro','Japanese & retro'], ['Type & Statements','Type & statements'],
        ['Cocktail Prints','Cocktail prints'], ['Playful & Positive','Playful & positive']
      ],
      rooms: [
        ['Living room','Living room'], ['Bedroom','Bedroom'], ['Kitchen','Kitchen'], ['Office','Office']
      ],
      materials: [
        ['Portrait','Portrait'], ['Landscape','Landscape']
      ],
      patterns: [],
      moods: [
        ['Bright','Bright'], ['Bold','Bold'], ['Soft','Soft'], ['Calm','Calm'],
        ['Dark','Dark'], ['Monochrome','Monochrome'], ['Warm','Warm']
      ],
      prices: priceRanges.map(function (range) { return [range.key, range.label]; }),
      availability: [['in-stock',copy.inStock]]
    };

    populateFilters();
    upgradeFilterDrawer();
    updateViewCounts();
    updateStickyOffset();
    syncViewButtons();
    syncFilterControls();
    render(false);

    root.addEventListener('click', onClick);
    root.addEventListener('change', onChange);
    root.addEventListener('pointerover', onPointerIntent, { passive: true });
    root.addEventListener('focusin', onPointerIntent);
    document.addEventListener('keydown', onKeydown);
    window.addEventListener('popstate', onPopState);
    window.addEventListener('scroll', requestStickyOffset, { passive: true });
    window.addEventListener('resize', requestStickyOffset, { passive: true });
    if (nextDataPage && (state.view !== 'all' || activeFilterCount() > 0 || new URLSearchParams(location.search).has('sort'))) ensureCollectionComplete().catch(function () {});

    function normalizeProduct(product) {
      product.price = Number(product.price || 0);
      product.compareAt = Number(product.compareAt || 0);
      product.manualOrder = Number(product.manualOrder || 9999);
      product.rating = Number(product.rating || 0);
      product.reviewCount = Number(product.reviewCount || 0);
      product.tags = arrayValue(product.tags);
      product.variants = arrayValue(product.variants).map(function (variant) {
        variant.price = Number(variant.price || 0);
        variant.compareAt = Number(variant.compareAt || 0);
        variant.options = arrayValue(variant.options);
        var overrideImage = variantOverrideImage(product.handle, variant);
        if (overrideImage) variant.image = overrideImage;
        return variant;
      });
      product.availableVariants = product.variants.filter(function (variant) { return variant.available; });
      product.available = product.availableVariants.length > 0;
      product.primaryPrice = product.availableVariants.length
        ? Math.min.apply(null, product.availableVariants.map(function (variant) { return variant.price; }))
        : product.price;
      product.group = '';
      product.groupTitle = product.title;
      product.designLabel = '';
      product.groupOrder = product.manualOrder;
      product.category = canonicalCategory(product.category, product);
      product.rooms = canonicalSingleList(product.rooms, canonicalRoom(product));
      product.materials = canonicalSingleList(product.materials, canonicalMaterial(product));
      product.patterns = canonicalSingleList(product.patterns, canonicalPattern(product));
      product.moods = canonicalSingleList(product.moods, canonicalMood(product));
      product.primaryRoom = product.rooms[0] || 'For the wall';
      product.classification = product.classification || product.category || product.type || 'Art print';
      product.fact = product.fact || fallbackFact(product);
      product.badge = product.badge || defaultBadge(product);
      return product;
    }

    function arrayValue(value) {
      return Array.isArray(value) ? value : [];
    }

    function readVariantImageOverrides() {
      var node = root.querySelector('[data-sh-variant-image-overrides]');
      var map = Object.create(null);
      if (!node) return map;
      try {
        arrayValue(JSON.parse(node.textContent || '[]')).forEach(function (entry) {
          if (!entry || !entry.product || !entry.option || !entry.image) return;
          map[String(entry.product) + '::' + normalizedToken(entry.option)] = String(entry.image);
        });
      } catch (error) {
        console.warn('SickHaus variant image overrides could not be read.', error);
      }
      return map;
    }

    function variantOverrideImage(handle, variant) {
      var values = arrayValue(variant && variant.options).map(function (option) { return option && option.value; });
      values.push(variant && variant.title);
      for (var index = 0; index < values.length; index += 1) {
        var key = String(handle || '') + '::' + normalizedToken(values[index]);
        if (variantImageOverrides[key]) return variantImageOverrides[key];
      }
      return '';
    }

    function cardDisplayVariant(product) {
      var preferred = preferredVariantByProduct[product.handle];
      return product.variants.find(function (variant) { return String(variant.id) === String(preferred); })
        || product.availableVariants.find(function (variant) { return variant.price === product.primaryPrice; })
        || product.availableVariants[0]
        || product.variants[0]
        || null;
    }

    function normalizedToken(value) {
      return String(value || '')
        .trim().toLowerCase().replace(/&/g, 'and')
        .replace(/[\s_]+/g, '-').replace(/[^a-z0-9-]+/g, '')
        .replace(/-+/g, '-');
    }

    function productHaystack(product) {
      return [product.title, product.type].concat(product.tags).join(' ').toLowerCase();
    }

    function canonicalGroup(value, tags) {
      var direct = normalizedToken(value);
      if (ALLOWED_MULTI_PRODUCT_GROUPS.has(direct)) return direct;
      var found = arrayValue(tags).map(String).find(function (tag) {
        return tag.toLowerCase().indexOf('lighting:collection-group:') === 0;
      });
      var candidate = found ? normalizedToken(found.split(':').pop()) : '';
      return ALLOWED_MULTI_PRODUCT_GROUPS.has(candidate) ? candidate : '';
    }

    function familyDesignLabel(title, group) {
      if (!ALLOWED_MULTI_PRODUCT_GROUPS.has(group)) return '';
      var parts = String(title || '').split(/\s+-\s+/);
      return parts.length > 1 ? parts.slice(1).join(' - ').trim() : String(title || '');
    }

    function explicitFamilyOrder(group, label, fallback) {
      var list = FAMILY_ORDER[group];
      if (!list) return fallback;
      var token = normalizedToken(label);
      var index = list.indexOf(token);
      return index === -1 ? fallback : index + 1;
    }

    function tagValue(tags, prefix) {
      var wanted = String(prefix || '').toLowerCase();
      var found = arrayValue(tags).map(String).find(function (tag) {
        return tag.toLowerCase().indexOf(wanted) === 0;
      });
      return found ? found.slice(prefix.length).trim() : '';
    }

    function canonicalCategory(value, product) {
      var categories = ['Japanese & Retro','Type & Statements','Cocktail Prints','Playful & Positive'];
      var explicit = String(value || tagValue(product.tags,'art-style:') || '').trim();
      var matched = categories.find(function (item) { return normalizedToken(item) === normalizedToken(explicit); });
      if (matched) return matched;
      var text = productHaystack(product);
      if (/cocktail|mojito|aperol|martini|daiquiri|bloody mary/.test(text)) return 'Cocktail Prints';
      if (/japan|japanese|okinawa|koi|kanji|reaper|omen|tiger|evergreen|blossom|seasonal|blooming/.test(text)) return 'Japanese & Retro';
      if (/self care|self-care|what if|amor|manifestation|intentions|no means|existential|pussy power|play it twice|type|statement/.test(text)) return 'Type & Statements';
      return 'Playful & Positive';
    }

    function canonicalList(values) {
      var seen = new Set();
      return arrayValue(values).map(function (value) { return String(value || '').trim(); }).filter(function (value) {
        var key = normalizedToken(value); if (!key || seen.has(key)) return false; seen.add(key); return true;
      });
    }

    function canonicalSingleList(values, fallback) {
      var result = canonicalList(values);
      if (!result.length && fallback) result.push(fallback);
      return result;
    }

    function canonicalRoom(product) {
      var tagged = tagValue(product.tags,'art-room:');
      if (tagged) return tagged;
      var text = productHaystack(product);
      if (/cocktail|mojito|aperol|martini|daiquiri|bloody mary/.test(text)) return 'Kitchen';
      if (/existential|regular breaks|error 404|inner peace|play it twice/.test(text)) return 'Office';
      if (/self care|self-care|manifestation|blossom|bloom|garden|positivity|take it easy|fluttering|daisy/.test(text)) return 'Bedroom';
      return 'Living room';
    }

    function canonicalMaterial(product) {
      var tagged = tagValue(product.tags,'art-orientation:');
      if (tagged) return tagged;
      return product.category === 'Cocktail Prints' ? 'Landscape' : 'Portrait';
    }

    function canonicalPattern(product) {
      return tagValue(product.tags,'art-subject:') || '';
    }

    function canonicalMood(product) {
      var tagged = tagValue(product.tags,'art-mood:');
      if (tagged) return tagged;
      var text = productHaystack(product);
      if (/midnight|reaper|omen|existential|error 404|petite mort|do or die/.test(text)) return 'Dark';
      if (/blossom|evergreen|koi fish|seasonal|blooming/.test(text)) return 'Calm';
      if (/self care|self-care|take it easy|what if|amor|manifestation/.test(text)) return 'Soft';
      if (/black and white|monochrome/.test(text)) return 'Monochrome';
      if (/cocktail|aperol|daiquiri|bloody mary|mojito/.test(text)) return 'Warm';
      if (/do or die|sharp|no means|pussy power|tiger|koi life/.test(text)) return 'Bold';
      return 'Bright';
    }

    function fallbackFact(product) {
      if (product.type) return product.type + ' · multiple sizes';
      return copy.fallbackFact || 'Colourful art print · multiple sizes';
    }

    function defaultBadge(product) { return ''; }

    function groupProducts(list) {
      var map = new Map();
      list.forEach(function (product) {
        var canCombine = ALLOWED_MULTI_PRODUCT_GROUPS.has(product.group);
        var key = canCombine ? product.group : product.handle;
        if (!map.has(key)) {
          map.set(key, {
            key: key,
            title: canCombine ? product.groupTitle : product.title,
            order: canCombine ? product.manualOrder : product.manualOrder,
            badge: product.badge || '',
            members: []
          });
        }
        var group = map.get(key);
        group.members.push(product);
        group.order = Math.min(group.order, product.manualOrder);
        if (!group.badge && product.badge) group.badge = product.badge;
      });
      return Array.from(map.values()).map(function (group) {
        group.members.sort(function (a, b) {
          if (ALLOWED_MULTI_PRODUCT_GROUPS.has(group.key)) return a.groupOrder - b.groupOrder || a.manualOrder - b.manualOrder;
          return a.manualOrder - b.manualOrder;
        });
        return group;
      }).sort(function (a, b) { return a.order - b.order; });
    }

    function readStateFromUrl() {
      var params = new URLSearchParams(window.location.search);
      return {
        view: params.get('view') || 'all', categories:new Set(params.getAll('category')),
        rooms:new Set(params.getAll('room')), materials:new Set(params.getAll('material')),
        patterns:new Set(params.getAll('pattern')), moods:new Set(params.getAll('mood')), prices:new Set(params.getAll('price')),
        availability: params.get('availability') === 'all' ? new Set() : new Set(['in-stock']),
        sort: params.get('sort') || 'featured', limit: initialLimit
      };
    }

    function writeStateToUrl() {
      var params=new URLSearchParams(); if (state.view&&state.view!=='all') params.set('view',state.view);
      setParams(params,'category',state.categories); setParams(params,'room',state.rooms); setParams(params,'material',state.materials);
      setParams(params,'pattern',state.patterns); setParams(params,'mood',state.moods); setParams(params,'price',state.prices);
      if (!state.availability.has('in-stock')) params.set('availability','all'); if (state.sort&&state.sort!=='featured') params.set('sort',state.sort);
      var query=params.toString(); window.history.replaceState({shArtPosterIndex:true},'',collectionUrl+(query?'?'+query:''));
    }

    function setParams(params, key, values) {
      values.forEach(function (value) { params.append(key, value); });
    }

    async function onPopState() {
      state = readStateFromUrl();
      if(nextDataPage && (state.view !== 'all' || activeFilterCount() > 0 || state.sort !== 'featured')) {try {await ensureCollectionComplete();} catch(error) {return;}}
      if (sortSelect) sortSelect.value = state.sort;
      syncViewButtons(); syncFilterControls(); render(false);
    }

    function readCopy() {
      var node = root.querySelector('[data-sh-copy-data]');
      var defaults = {
        liveCount:'{count} active prints · multiple sizes · most supplied unframed.', emptyTitle:'Nothing quite matches that combination.',
        emptyBody:'Try removing a filter and we will bring more possibilities back into view.', emptyButton:'Clear all filters',
        resultsFormat:'{count} prints', loadNoteFormat:'{count} more prints to discover',
        quickAdd:'Quick add', unavailable:'Currently unavailable', familyNote:'{count} designs · tap a colour',
        includingUnavailable:'Including unavailable', showInStockOnly:'Show in-stock only', clearAll:'Clear all',
        viewAll:'All prints', viewUnder25:'Under £15', viewWall:'Japanese & retro', viewDecorative:'Type & statements', viewTabletop:'Cocktail prints',
        viewVases:'Playful & positive', viewStorage:'Art prints', viewSoft:'Soft colour', viewFurniture:'Statement artwork', addToBag:'Add to bag', adding:'Adding…',
        ready:'Ready to add.', combinationUnavailable:'This combination is currently unavailable.', toastSuccess:'Added to your bag.',
        addError:'We could not add that option. Please try again.', fallbackFact:'Colourful art print · multiple sizes',
        catDecorative:'Decorative objects', catWall:'Wall & display', catVases:'Vases & planters', catTabletop:'Tabletop',
        catStorage:'Storage & organisation', catSoft:'Soft furnishings', catFurniture:'Furniture accents', catEntryway:'Entryway',
        catSmall:'Small accessories', catFragrance:'Fragrance & candlelight', placeWall:'Wall', placeDesk:'Desk',
        placeTabletop:'Tabletop', placeShelf:'Shelf & sideboard', placeFloor:'Floor', placeSofa:'Sofa & bed', placeHanging:'Hanging',
        placeEntryway:'Entryway', placeMagnetic:'Magnetic surface', placeWearable:'Wearable', matAcrylic:'Acrylic', matCeramic:'Ceramic',
        matGlass:'Glass', matMetal:'Metal', matMirror:'Mirror', matResin:'Resin', matTextile:'Textile', matWood:'Wood',
        matLeather:'Leather', matPlastic:'Plastic', matMixed:'Mixed materials', matFoam:'Foam', matRubber:'Rubber', colourMono:'Monochrome', colourWarm:'Warm tones',
        colourPink:'Pink & red', colourGreen:'Green & blue', colourChrome:'Chrome & metallic', colourClear:'Clear & translucent',
        colourMulti:'Multicolour', colourNeutral:'Neutral', inStock:'In stock', fromLabel:'From', viewProductAria:'View {title}',
        saveProductAria:'Save {title}', chooseOptionAria:'Choose {option}', removeFilterAria:'Remove {filter}'
      };
      if (!node) return defaults;
      try { return Object.assign(defaults, JSON.parse(node.textContent || '{}')); }
      catch (error) { return defaults; }
    }

    function formatCopy(template, values) {
      return String(template || '').replace(/\{([a-zA-Z0-9_]+)\}/g, function (_, key) {
        return Object.prototype.hasOwnProperty.call(values || {}, key) ? values[key] : '';
      });
    }

    function readPriceRanges() {
      var node = root.querySelector('[data-sh-price-range-data]');
      if (node) { try { var parsed=JSON.parse(node.textContent||'[]'); var valid=parsed.filter(function (range) { return range&&range.key&&range.label&&Number.isFinite(Number(range.min))&&(range.max===null||Number.isFinite(Number(range.max))); }).map(function (range) { return {key:String(range.key),label:String(range.label),min:Number(range.min),max:range.max===null?null:Number(range.max)}; }); if (valid.length) return valid; } catch (error) {} }
      return [
        {key:'under15',min:0,max:1500,label:'Up to '+money(1500)},
        {key:'15-25',min:1501,max:2500,label:money(1500)+'–'+money(2500)},
        {key:'25-40',min:2501,max:4000,label:money(2500)+'–'+money(4000)},
        {key:'40plus',min:4001,max:null,label:money(4000)+'+'}
      ];
    }

    var draftFilterState = null;
    function applyDraftFilters() {
      if(draftFilterState)Object.keys(draftFilterState).forEach(function(key){state[key]=new Set(draftFilterState[key]);});else readFilterControls();
      state.view='all';state.limit=initialLimit;syncViewButtons();render();closeDrawer();scrollToFirstProductCard();
    }
    function upgradeFilterDrawer() {
      filterDrawer.addEventListener('keydown',function(event){
        if(event.key!=='Tab')return;
        var focusable=Array.from(filterDrawer.querySelectorAll('button:not(:disabled),summary,input:not(:disabled)')).filter(function(node){return node.getClientRects().length;});
        var first=focusable[0],last=focusable[focusable.length-1];
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
      });
      filterDrawer.querySelector('[data-sh-apply-filters]').addEventListener('click',function(event){event.stopPropagation();applyDraftFilters();});
      filterDrawer.querySelector('[data-sh-close-filters]').addEventListener('click',function(event){event.stopPropagation();closeDrawer();});
      var body=filterDrawer.querySelector('.sh-pi__drawer-body');
      var selected=document.createElement('div');selected.className='sh-pi__drawer-selection';
      selected.innerHTML='<div><span data-sh-draft-label></span><button type="button" data-sh-draft-clear>Clear all</button></div><div data-sh-draft-chips></div><p data-sh-draft-empty hidden>No matches. Remove a filter or clear all to explore again.</p>';
      body.prepend(selected);
      ['categories','prices'].concat(Object.keys(filterDefinitions).filter(function(key){return key!=='categories'&&key!=='prices';})).forEach(function(key,index){
        var options=body.querySelector('[data-sh-filter-options="'+key+'"]');if(!options)return;
        var fieldset=options.closest('fieldset');if(!fieldset)return;
        var details=document.createElement('details');details.className='sh-pi__filter-group';details.open=index<2;
        var summary=document.createElement('summary');var title=document.createElement('strong');title.textContent=fieldset.querySelector('legend').textContent;
        var wrap=document.createElement('span');wrap.append(title);var subtitle=document.createElement('small');subtitle.dataset.shDraftSummary=key;wrap.append(subtitle);summary.append(wrap);var icon=document.createElement('i');icon.setAttribute('aria-hidden','true');summary.append(icon);details.append(summary,options);fieldset.remove();body.append(details);
      });
      var clear=filterDrawer.querySelector('[data-sh-reset-filters]');if(clear)clear.hidden=true;
      filterDrawer.addEventListener('change',function(event){if(event.target.matches('[data-sh-filter-input]'))updateDraftFilters();});
      filterDrawer.addEventListener('click',function(event){
        var button=event.target.closest('[data-sh-draft-clear],[data-sh-draft-remove]');if(!button)return;
        filterDrawer.querySelectorAll('[data-sh-filter-input]').forEach(function(input){if(button.hasAttribute('data-sh-draft-clear')||(input.dataset.shFilterInput===button.dataset.shDraftRemove&&input.value===button.dataset.value))input.checked=false;});updateDraftFilters();
      });
    }

    function updateDraftFilters() {
      var saved={};Object.keys(filterDefinitions).forEach(function(key){saved[key]=state[key];});
      var savedView=state.view;state.view='all';readFilterControls();
      var total=products.filter(productMatches).length,selected=0;
      var chips=filterDrawer.querySelector('[data-sh-draft-chips]');chips.replaceChildren();
      Object.keys(saved).forEach(function(key){
        var labels=[];state[key].forEach(function(value){selected++;var entry=filterDefinitions[key].find(function(option){return option[0]===value;});var label=entry?entry[1]:value;labels.push(label);var button=document.createElement('button');button.type='button';button.dataset.shDraftRemove=key;button.dataset.value=value;button.textContent=label+' ×';button.setAttribute('aria-label','Remove '+label);chips.append(button);});
        var summary=filterDrawer.querySelector('[data-sh-draft-summary="'+key+'"]');if(summary)summary.textContent=labels.join(', ');
      });
      filterDrawer.querySelector('[data-sh-draft-label]').textContent=selected?selected+' filter'+(selected===1?'':'s')+' selected':'All products';
      filterDrawer.querySelector('[data-sh-draft-clear]').disabled=!selected;
      filterDrawer.querySelector('[data-sh-draft-empty]').hidden=total>0;
      var apply=filterDrawer.querySelector('[data-sh-apply-filters]');apply.textContent=total?'Show '+total+' product'+(total===1?'':'s'):'No matching products';apply.disabled=!total;
      state.view=savedView;
      if(nextDataPage){apply.textContent='Apply filters';apply.disabled=false;filterDrawer.querySelector('[data-sh-draft-empty]').hidden=true;}
      draftFilterState={};Object.keys(saved).forEach(function(key){draftFilterState[key]=new Set(state[key]);state[key]=saved[key];});
    }

    function populateFilters() {
      Object.keys(filterDefinitions).forEach(function (groupName) {
        var container = root.querySelector('[data-sh-filter-options="' + groupName + '"]');
        if (!container) return;
        container.innerHTML = filterDefinitions[groupName].map(function (entry) {
          var count = optionProductCount(groupName, entry[0]);
          return '<label class="sh-pi__check"><input type="checkbox" value="' + escapeHtml(entry[0]) + '" data-sh-filter-input="' + groupName + '"><span>' + escapeHtml(entry[1]) + '</span><small>' + count + '</small></label>';
        }).join('');
      });
    }

    function optionProductCount(groupName, value) {
      return products.filter(function (product) {
        if (groupName==='categories') return product.category===value;
        if (groupName==='rooms') return product.rooms.indexOf(value)!==-1;
        if (groupName==='materials') return product.materials.indexOf(value)!==-1;
        if (groupName==='patterns') return product.patterns.indexOf(value)!==-1;
        if (groupName==='moods') return product.moods.indexOf(value)!==-1;
        if (groupName==='prices') return priceMatches(product.primaryPrice,value);
        if (groupName==='availability') return value==='in-stock'?product.available:true;
        return false;
      }).length;
    }

    function updateViewCounts() {
      root.querySelectorAll('[data-sh-view-count]').forEach(function (node) { var view=node.dataset.shViewCount; node.textContent=products.filter(function (product) { return viewMatches(product,view); }).length; });
      var liveCounter=root.querySelector('[data-sh-live-product-count]'); if (liveCounter) liveCounter.textContent=formatCopy(copy.liveCount,{count:products.length});
    }

    function syncFilterControls() {
      root.querySelectorAll('[data-sh-filter-input]').forEach(function (input) {
        input.checked = state[input.dataset.shFilterInput].has(input.value);
      });
    }

    function syncViewButtons() {
      root.querySelectorAll('[data-sh-view]').forEach(function (button) {
        button.classList.toggle('is-active', button.dataset.shView === state.view);
      });
    }


    // Preserve the server-rendered cards when hydration has no results to change.
    function hasSameRenderedProducts(entries) {
      var cards = Array.from(grid.children).filter(function(node) {
        return node.matches('[data-sh-uc-card], [data-sh-card]');
      });
      return cards.length === entries.length && cards.every(function(card, index) {
        return (card.dataset.productHandle || card.dataset.shCard || card.dataset.handle) === entries[index].selected.handle;
      });
    }
    function render(updateUrl) {
      if (updateUrl !== false) writeStateToUrl();
      var visible=groups.map(function (group) { var matching=group.members.filter(productMatches); if (!matching.length) return null; var selected=matching[0]; return {group:group,matching:matching,selected:selected}; }).filter(Boolean);
      visible.sort(sortGroupEntries); var shown=visible.slice(0,state.limit);
      if (!shown.length) grid.innerHTML='<div class="sh-pi__empty"><h3>'+escapeHtml(copy.emptyTitle)+'</h3><p>'+escapeHtml(copy.emptyBody)+'</p><button type="button" data-sh-clear-all>'+escapeHtml(copy.emptyButton)+'</button></div>';
      else if (!hasSameRenderedProducts(shown)) {
        var editorialNode=root.querySelector('[data-sh-editorial-template]'); var editorial=editorialNode?editorialNode.innerHTML:'';
        grid.innerHTML=shown.map(function (entry,index) { return cardMarkup(entry,index)+(index===11&&editorial?editorial:''); }).join('');
      }
      resultsCount.textContent=formatCopy(copy.resultsFormat,{count:visible.length,designs:visible.length,products:visible.length}) + (nextDataPage ? " loaded" : "");
      var remaining=Math.max(0,visible.length-shown.length); if (loadWrap) loadWrap.hidden = remaining === 0 && !nextDataPage; if (loadNote) loadNote.textContent = nextDataPage ? 'More pieces to explore' : remaining ? formatCopy(copy.loadNoteFormat,{count:remaining}) : '';
      renderApplied(); animateCards();
    }

    function productMatches(product) {
      if (!viewMatches(product,state.view)) return false;
      if (state.categories.size&&!state.categories.has(product.category)) return false;
      if (state.rooms.size&&!intersects(product.rooms,state.rooms)) return false;
      if (state.materials.size&&!intersects(product.materials,state.materials)) return false;
      if (state.patterns.size&&!intersects(product.patterns,state.patterns)) return false;
      if (state.moods.size&&!intersects(product.moods,state.moods)) return false;
      if (state.prices.size&&!Array.from(state.prices).some(function (range) { return priceMatches(product.primaryPrice,range); })) return false;
      if (state.availability.has('in-stock')&&!product.available) return false;
      return true;
    }

    function viewMatches(product, view) {
      if (view==='all') return true;
      if (view==='under15') return product.primaryPrice<=1500;
      if (view==='japanese') return product.category==='Japanese & Retro';
      if (view==='type') return product.category==='Type & Statements';
      if (view==='cocktail') return product.category==='Cocktail Prints';
      if (view==='playful') return product.category==='Playful & Positive';
      return true;
    }

    function intersects(values, selected) {
      return values.some(function (value) { return selected.has(value); });
    }

    function priceMatches(price, key) {
      var range = priceRanges.find(function (entry) { return entry.key === key; });
      if (!range) return true;
      var amount = Number(price || 0);
      if (amount < range.min) return false;
      return range.max === null ? true : amount <= range.max;
    }

    function sortGroupEntries(a, b) {
      if (state.sort === 'price-asc') return minimumMatchingPrice(a) - minimumMatchingPrice(b);
      if (state.sort === 'price-desc') return minimumMatchingPrice(b) - minimumMatchingPrice(a);
      if (state.sort === 'reviewed') return maximumReviewCount(b) - maximumReviewCount(a) || a.group.order - b.group.order;
      return a.group.order - b.group.order;
    }

    function minimumMatchingPrice(entry) {
      return Math.min.apply(null, entry.matching.map(function (product) { return product.primaryPrice; }));
    }

    function maximumReviewCount(entry) {
      return Math.max.apply(null, entry.matching.map(function (product) { return product.reviewCount || 0; }));
    }

    function cardMarkup(entry, index) {
      var group = entry.group;
      var product = entry.selected;
      var members = entry.matching;
      var selectedIndex = members.findIndex(function (member) { return member.handle === product.handle; });
      var controls = members.length > 1 ? memberSwatches(members, selectedIndex, group.key) : productSwatches(product);
      var quick = product.available
        ? '<button class="sh-pi__quick-button" type="button" data-sh-quick="' + escapeHtml(product.handle) + '" data-sh-quick-group="' + escapeHtml(group.key) + '">' + escapeHtml(copy.quickAdd) + '</button>'
        : '<span class="sh-pi__sold">'+escapeHtml(copy.unavailable)+'</span>';
      var familyNote = '';
      var rating = '<span class="sh-pi__rating" data-sh-card-rating' + (product.rating > 0 ? '' : ' hidden') + '>' +
        (product.rating > 0 ? '<strong>★ ' + product.rating.toFixed(1) + '</strong>' + (product.reviewCount ? ' (' + product.reviewCount + ')' : '') : '') + '</span>';
      var savedClass = saved.has(group.key) ? ' is-saved' : '';
      var displayVariant = cardDisplayVariant(product);
      var image = product.image || '';
      var secondary = [product.secondaryImage, product.image].find(function(source){return source && source.split('?')[0] !== image.split('?')[0];}) || image;
      var label = product.primaryRoom;
      return '<article class="sh-pi__card" data-sh-card data-group="' + escapeHtml(group.key) + '" data-handle="' + escapeHtml(product.handle) + '" style="--sh-delay:' + Math.min(index, 15) * 32 + 'ms">' +
        '<div class="sh-pi__media"><a href="' + escapeHtml(product.url + (displayVariant ? '?variant=' + encodeURIComponent(displayVariant.id) : '')) + '" aria-label="' + escapeHtml(formatCopy(copy.viewProductAria,{title:product.title})) + '" data-sh-product-link>' +
          '<img ' + window.SHResponsiveCards.attributes(image) + ' alt="' + escapeHtml(product.imageAlt || product.title) + '" loading="lazy" data-sh-primary-image>' +
          '<img ' + window.SHResponsiveCards.attributes(secondary, true, image) + ' alt="" loading="lazy" aria-hidden="true" data-sh-secondary-image></a>' +
          (product.badge ? '<span class="sh-pi__badge" data-sh-card-badge>' + escapeHtml(product.badge) + '</span>' : '') +
          '<button class="sh-pi__save' + savedClass + '" type="button" data-sh-save="' + escapeHtml(group.key) + '" aria-label="' + escapeHtml(formatCopy(copy.saveProductAria,{title:group.title})) + '" aria-pressed="' + (saved.has(group.key) ? 'true' : 'false') + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.4 4.5 13.2A4.9 4.9 0 0 1 11.4 6l.6.7.6-.7a4.9 4.9 0 0 1 6.9 7.2Z"/></svg></button>' + familyNote + quick + '</div>' +
        '<div class="sh-pi__info"><div class="sh-pi__kicker"><span data-sh-card-classification>' + escapeHtml(product.classification) + '</span><span data-sh-card-label>' + escapeHtml(label) + '</span></div>' +
          '<div class="sh-pi__title-row"><h3><a href="' + escapeHtml(product.url + (displayVariant ? '?variant=' + encodeURIComponent(displayVariant.id) : '')) + '" data-sh-card-title data-sh-product-link>' + escapeHtml(group.title) + '</a></h3><div class="sh-pi__price" data-sh-card-price>' + priceMarkup(product) + '</div></div>' +
          '<p class="sh-pi__fact" data-sh-card-fact>' + escapeHtml(product.fact) + '</p>' +
          '<div class="sh-pi__card-footer"><div class="sh-pi__swatches" data-sh-card-swatches>' + controls + '</div>' + rating + '</div></div></article>';
    }

    function memberSwatches(members, selectedIndex, groupKey) {
      var visible = members;
      var markup = visible.map(function (member, index) {
        return '<button type="button" class="sh-pi__swatch' + (index === selectedIndex ? ' is-active' : '') + '" style="background:' + colourFor(member.patterns[0] || member.designLabel || member.title) + '" data-sh-member="' + escapeHtml(member.handle) + '" data-sh-group="' + escapeHtml(groupKey) + '" aria-label="' + escapeHtml(formatCopy(copy.chooseOptionAria,{option:member.designLabel||member.title})) + '" title="' + escapeHtml(member.designLabel || member.title) + '"></button>';
      }).join('');
      if (members.length > visible.length) markup += '<span class="sh-pi__swatch-count">+' + (members.length - visible.length) + '</span>';
      return markup;
    }

    function productSwatches(product) {
      var choices = colourVariantChoices(product);
      if (!choices.length) return '';
      var preferred = preferredVariantByProduct[product.handle];
      return choices.map(function (choice, index) {
        var active = preferred ? String(choice.variantId) === String(preferred) : index === 0;
        return '<button type="button" class="sh-pi__swatch' + (active ? ' is-active' : '') + '" style="background:' + colourFor(choice.label) + '" data-sh-product-swatch="' + escapeHtml(product.handle) + '"' + (choice.variantId ? ' data-variant-id="' + choice.variantId + '"' : '') + ' aria-label="' + escapeHtml(formatCopy(copy.chooseOptionAria,{option:choice.label})) + '" title="' + escapeHtml(choice.label) + '"></button>';
      }).join('');
    }

    function isColourOptionName(name) {
      var normalized = String(name || '').trim().toLowerCase().replace(/\s+/g, ' ');
      return normalized.indexOf('colour') !== -1 ||
        normalized.indexOf('color') !== -1 ||
        normalized.indexOf('finish') !== -1 ||
        normalized.indexOf('upholstery') !== -1 ||
        normalized.indexOf('fabric') !== -1 ||
        normalized === 'material' ||
        normalized === 'style' ||
        normalized === 'design' ||
        normalized === 'shade' ||
        normalized === 'colourway';
    }

    function colourVariantChoices(product) {
      var byLabel = new Map();
      product.variants.forEach(function (variant) {
        var option = variant.options.find(function (entry) { return isColourOptionName(entry.name); });
        if (!option) return;
        var label = String(option.value || '').trim();
        var key = label.toLowerCase();
        if (!label) return;
        var current = byLabel.get(key);
        if (!current || (!current.available && variant.available)) {
          byLabel.set(key, { label: label, variantId: variant.id, available: !!variant.available });
        }
      });
      return Array.from(byLabel.values());
    }

    function priceMarkup(product, variant) {
      var display = variant || product.availableVariants.find(function (item) { return item.price === product.primaryPrice; }) || product.variants[0] || null;
      var price = display ? display.price : product.price;
      var compareAt = display ? display.compareAt : product.compareAt;
      var formattedPrice = display && display.priceFormatted ? display.priceFormatted : (product.priceFormatted || money(price));
      var formattedCompare = display && display.compareAtFormatted ? display.compareAtFormatted : (product.compareAtFormatted || money(compareAt));
      var from = !variant && product.availableVariants.some(function (item) { return item.price !== product.primaryPrice; }) ? '<small>' + escapeHtml(copy.fromLabel) + ' </small>' : '';
      return (compareAt > price ? '<s>' + formattedCompare + '</s>' : '') + '<span>' + from + formattedPrice + '</span>';
    }

    function money(cents) {
      var amount = Number(cents || 0) / 100;
      try { return new Intl.NumberFormat(locale, { style:'currency', currency:currency }).format(amount); }
      catch (error) { return currency + ' ' + amount.toFixed(amount % 1 ? 2 : 0); }
    }

    function colourFor(value) {
      var key = String(value || '').toLowerCase();
      if (/multicolour|colourful|rainbow|gradient/.test(key)) return 'linear-gradient(135deg,#ff5b2f,#ef75c6 50%,#6578ff)';
      if (/chrome|metallic|silver/.test(key)) return 'linear-gradient(135deg,#f5f5f3,#8f9295 52%,#e7e8e8)';
      var map = { orange:'#e76b2c', yellow:'#e8bd23', red:'#a91d24', green:'#718a67', blue:'#4d6d93', cool:'#6886a9', pink:'#dda2b2', black:'#1c1c1c', white:'#f1eee6', cream:'#dfd2b9', grey:'#9b9d9b', gray:'#9b9d9b', neutral:'#d8d0c4', brown:'#8b684d', gold:'#c7a451', warm:'#c9844d', monochrome:'linear-gradient(135deg,#151515 0 50%,#f2f0e9 50%)' };
      var found = Object.keys(map).find(function (name) { return key.indexOf(name) !== -1; });
      return found ? map[found] : '#d8d0c4';
    }

    function renderApplied() {
      var labels=Object.create(null); Object.keys(filterDefinitions).forEach(function (group) { filterDefinitions[group].forEach(function (entry) { labels[entry[0]]=entry[1]; }); });
      var html=''; [['categories',state.categories],['rooms',state.rooms],['materials',state.materials],['patterns',state.patterns],['moods',state.moods],['prices',state.prices]].forEach(function (entry) { entry[1].forEach(function (value) { html+='<span class="sh-pi__chip">'+escapeHtml(labels[value]||value)+'<button type="button" data-sh-remove-filter="'+entry[0]+'" data-value="'+escapeHtml(value)+'" aria-label="'+escapeHtml(formatCopy(copy.removeFilterAria,{filter:labels[value]||value}))+'">×</button></span>'; }); });
      if (!state.availability.has('in-stock')) html+='<span class="sh-pi__chip">'+escapeHtml(copy.includingUnavailable)+'<button type="button" data-sh-stock-only aria-label="'+escapeHtml(copy.showInStockOnly)+'">×</button></span>';
      if (state.view!=='all') html+='<span class="sh-pi__chip">'+escapeHtml(viewLabel(state.view))+'<button type="button" data-sh-view="all" aria-label="'+escapeHtml(copy.viewAll)+'">×</button></span>';
      if (activeFilterCount()||state.view!=='all') html+='<button class="sh-pi__clear-all" type="button" data-sh-clear-all>'+escapeHtml(copy.clearAll)+'</button>';
      applied.innerHTML=html; var count=activeFilterCount(); filterCount.hidden=!count; filterCount.textContent=count;
    }

    function activeFilterCount() { return state.categories.size+state.rooms.size+state.materials.size+state.patterns.size+state.moods.size+state.prices.size+(state.availability.has('in-stock')?0:1); }

    function viewLabel(view) { return {under15:copy.viewUnder25,japanese:copy.viewWall,type:copy.viewDecorative,cocktail:copy.viewTabletop,playful:copy.viewVases}[view]||copy.viewAll; }

    function animateCards() {
      var cards = grid.querySelectorAll('[data-sh-card]');
      if (!('IntersectionObserver' in window) || prefersReducedMotion()) { cards.forEach(function (card) { card.classList.add('is-visible'); }); return; }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.style.animationDelay = entry.target.style.getPropertyValue('--sh-delay') || '0ms';
          entry.target.classList.add('is-visible'); observer.unobserve(entry.target);
        });
      }, { threshold:.05, rootMargin:'100px 0px' });
      cards.forEach(function (card) { observer.observe(card); });
    }

    async function onClick(event) {
      if (nextDataPage && event.target.closest('[data-sh-open-filters],[data-sh-view],[data-sh-preset],[data-sh-load-more],[data-sh-clear-all],[data-sh-reset-filters]')) {
        try { await ensureCollectionComplete(); } catch (error) { showToast('Could not load more pieces. Please try again.'); return; }
      }
      var button = event.target.closest('button');
      if (!button || !root.contains(button)) return;
      if (button.matches('[data-sh-open-filters]')) return openDrawer(button);
      if (button.matches('[data-sh-close-filters]')) return closeDrawer();
      if (button.matches('[data-sh-reset-filters]')) { clearFilterSets(); syncFilterControls(); return; }
      if (button.matches('[data-sh-apply-filters]')) { readFilterControls(); state.view='all'; state.limit=initialLimit; syncViewButtons(); render(); closeDrawer(); scrollToFirstProductCard(); return; }
      if (button.matches('[data-sh-view]')) { state.view=button.dataset.shView || 'all'; clearFilterSets(); state.availability=new Set(['in-stock']); state.limit=initialLimit; syncViewButtons(); syncFilterControls(); render(); scrollToFirstProductCard(); return; }
      if (button.matches('[data-sh-preset]')) return applyPreset(button.dataset.shPreset);
      if (button.matches('[data-sh-load-more]')) { state.limit += loadIncrement; render(); return; }
      if (button.matches('[data-sh-clear-all]')) return clearFilters(true);
      if (button.matches('[data-sh-remove-filter]')) { state[button.dataset.shRemoveFilter].delete(button.dataset.value); state.limit=initialLimit; syncFilterControls(); render(); return; }
      if (button.matches('[data-sh-stock-only]')) { state.availability=new Set(['in-stock']); syncFilterControls(); render(); return; }
      if (button.matches('[data-sh-save]')) return toggleSaved(button.dataset.shSave, button);
      if (button.matches('[data-sh-member]')) return switchGroupMember(button);
      if (button.matches('[data-sh-product-swatch]')) return switchProductVariant(button);
      if (button.matches('[data-sh-quick]')) return openQuick(button.dataset.shQuick, button.dataset.shQuickGroup, button);
      if (button.matches('[data-sh-family-choice]')) return switchQuickFamily(button.dataset.shFamilyChoice);
      if (button.matches('[data-sh-close-quick]')) return closeQuick();
      if (button.matches('[data-sh-modal-add]')) return addActiveVariant(button);
    }

    async function onChange(event) {
      if (nextDataPage && event.target.matches('[data-sh-sort],[data-sh-filter-input]')) {
        if (event.target.matches('[data-sh-filter-input]')) readFilterControls();
        try { await ensureCollectionComplete(); } catch (error) { showToast('Could not load more pieces. Please try again.'); return; }
      }
      if (event.target.matches('[data-sh-sort]')) { state.sort=event.target.value; state.limit=initialLimit; render(); return; }
      if (event.target.matches('[data-sh-quick-option]')) updateModalVariant();
    }

    function onPointerIntent(event) {
      var member = event.target.closest('[data-sh-member]');
      if (member) {
        var product = products.find(function (item) { return item.handle === member.dataset.shMember; });
        if (product) preloadProductAssets(product);
      }
      var card = event.target.closest('[data-sh-card]');
      if (card) {
        var active = products.find(function (item) { return item.handle === card.dataset.handle; });
        if (active) preloadProductAssets(active);
      }
    }

    function applyPreset(preset) {
      state.view='all'; clearFilterSets(); state.availability=new Set(['in-stock']); state.limit=initialLimit;
      var parts=String(preset||'').split(':'); var type=parts.shift(); var value=parts.join(':');
      if (type==='category'&&value) state.categories.add(value);
      else if (type==='room'&&value) state.rooms.add(value);
      else if (type==='material'&&value) state.materials.add(value);
      else if (type==='pattern'&&value) state.patterns.add(value);
      else if (type==='mood'&&value) state.moods.add(value);
      else if (type==='price'&&value) state.prices.add(value);
      else if (preset==='bedroom') state.rooms.add('Bedroom');
      else if (preset==='living') state.rooms.add('Living room');
      else if (preset==='kitchen') state.rooms.add('Kitchen');
      else if (preset==='office') state.rooms.add('Office');
      syncViewButtons(); syncFilterControls(); render(); scrollToFirstProductCard();
    }

    function switchGroupMember(button) {
      var groupKey = button.dataset.shGroup;
      var handle = button.dataset.shMember;
      var group = groups.find(function (item) { return item.key === groupKey; });
      var card = button.closest('[data-sh-card]');
      if (!group || !card || !ALLOWED_MULTI_PRODUCT_GROUPS.has(groupKey)) return;
      var matching = group.members.filter(productMatches);
      var selected = matching.find(function (product) { return product.handle === handle; });
      if (!selected || selected.handle === card.dataset.handle) return;
      selectedByGroup[groupKey] = selected.handle;
      var token = String(++switchSequence); card.dataset.shSwitchToken=token; button.setAttribute('aria-busy','true');
      preloadProductAssets(selected).then(function () {
        if (!card.isConnected || card.dataset.shSwitchToken !== token) return;
        patchCard(card, { group:group, matching:matching, selected:selected });
      }).finally(function () { if (button.isConnected) button.removeAttribute('aria-busy'); });
    }

    function switchProductVariant(button) {
      var product = products.find(function (item) { return item.handle === button.dataset.shProductSwatch; });
      var card = button.closest('[data-sh-card]');
      if (!product || !card || !button.dataset.variantId) return;
      var variant = product.variants.find(function (item) { return String(item.id) === String(button.dataset.variantId); });
      if (!variant) return;
      preferredVariantByProduct[product.handle]=variant.id;
      card.querySelectorAll('[data-sh-product-swatch]').forEach(function (swatch) { swatch.classList.remove('is-active'); }); button.classList.add('is-active');
      var option = variant.options.find(function (entry) { return isColourOptionName(entry.name); });
      setText(card,'[data-sh-card-label]', option ? option.value : product.primaryRoom);
      var priceNode=card.querySelector('[data-sh-card-price]'); if (priceNode) priceNode.innerHTML=priceMarkup(product,variant);
      card.querySelectorAll('[data-sh-product-link]').forEach(function (link) { link.href=product.url+'?variant='+encodeURIComponent(variant.id); });
      if (!variant.image) return;
      var token=String(++switchSequence); card.dataset.shSwitchToken=token;
      preloadImage(variant.image).then(function () { if (card.isConnected && card.dataset.shSwitchToken===token) crossfadeCardImage(card,variant.image,product.imageAlt||product.title,variant.image); });
    }

    function patchCard(card, entry) {
      var group=entry.group, product=entry.selected, members=entry.matching;
      var selectedIndex=members.findIndex(function (member) { return member.handle===product.handle; });
      card.dataset.handle=product.handle;
      card.querySelectorAll('[data-sh-product-link]').forEach(function (link) { link.href=product.url; if (link.hasAttribute('aria-label')) link.setAttribute('aria-label','View '+product.title); });
      crossfadeCardImage(card,product.image||'',product.imageAlt||product.title,product.secondaryImage||product.image||'');
      setText(card,'[data-sh-card-classification]',product.classification);
      setText(card,'[data-sh-card-label]',product.designLabel||product.impact);
      setText(card,'[data-sh-card-title]',group.title);
      setText(card,'[data-sh-card-fact]',product.fact);
      var priceNode=card.querySelector('[data-sh-card-price]'); if (priceNode) priceNode.innerHTML=priceMarkup(product);
      var swatches=card.querySelector('[data-sh-card-swatches]'); if (swatches) swatches.innerHTML=members.length>1?memberSwatches(members,selectedIndex,group.key):productSwatches(product);
      updateCardRating(card,product); updateCardBadge(card,product.badge); updateCardAction(card,product,group.key);
      var note=card.querySelector('[data-sh-family-note]'); if (note) note.textContent=formatCopy(copy.familyNote,{count:members.length});
      card.classList.add('is-product-updated'); window.setTimeout(function () { card.classList.remove('is-product-updated'); },420);
    }

    function updateCardRating(card, product) {
      var node=card.querySelector('[data-sh-card-rating]'); if (!node) return;
      if (product.rating>0) { node.hidden=false; node.innerHTML='<strong>★ '+product.rating.toFixed(1)+'</strong>'+(product.reviewCount?' ('+product.reviewCount+')':''); }
      else { node.hidden=true; node.textContent=''; }
    }

    function updateCardBadge(card, value) {
      var media=card.querySelector('.sh-pi__media'); var badge=card.querySelector('[data-sh-card-badge]');
      if (!value) { if (badge) badge.remove(); return; }
      if (!badge && media) { badge=document.createElement('span'); badge.className='sh-pi__badge'; badge.setAttribute('data-sh-card-badge',''); media.appendChild(badge); }
      if (badge) badge.textContent=value;
    }

    function updateCardAction(card, product, groupKey) {
      var media=card.querySelector('.sh-pi__media'); var quick=card.querySelector('[data-sh-quick]'); var sold=card.querySelector('.sh-pi__sold');
      if (product.available) {
        if (sold) sold.remove();
        if (!quick && media) { quick=document.createElement('button'); quick.className='sh-pi__quick-button'; quick.type='button'; quick.textContent=copy.quickAdd; media.appendChild(quick); }
        quick.dataset.shQuick=product.handle; quick.dataset.shQuickGroup=groupKey;
      } else {
        if (quick) quick.remove();
        if (!sold && media) { sold=document.createElement('span'); sold.className='sh-pi__sold'; sold.textContent=copy.unavailable; media.appendChild(sold); }
      }
    }

    function setText(scope, selector, value) { var node=scope.querySelector(selector); if (node) node.textContent=value||''; }

    function preloadProductAssets(product) { return Promise.all([preloadImage(product.image),preloadImage(product.secondaryImage||product.image)]); }
    function preloadImage(url) {
      if (!url) return Promise.resolve();
      if (imagePromises.has(url)) return imagePromises.get(url);
      var promise=new Promise(function (resolve) { var image=new Image(); image.onload=function () { if (typeof image.decode==='function') image.decode().catch(function () {}).finally(resolve); else resolve(); }; image.onerror=resolve; image.src=url; if (image.complete) image.onload(); });
      imagePromises.set(url,promise); return promise;
    }

    function crossfadeCardImage(card, source, alt, secondarySource) {
      var anchor=card.querySelector('.sh-pi__media > a'), primary=card.querySelector('[data-sh-primary-image]'), secondary=card.querySelector('[data-sh-secondary-image]');
      if (!anchor || !primary || !source) return;
      if (primary.getAttribute('src')===source || primary.src===source) { primary.alt=alt||''; if (secondary&&secondarySource) window.SHResponsiveCards.set(secondary,secondarySource); return; }
      anchor.querySelectorAll('.sh-pi__transition-image').forEach(function (item) { item.remove(); });
      var overlay=document.createElement('img'); overlay.className='sh-pi__transition-image'; overlay.src=source; overlay.alt=''; overlay.setAttribute('aria-hidden','true'); anchor.appendChild(overlay);
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { overlay.classList.add('is-active'); }); });
      window.setTimeout(function () { window.SHResponsiveCards.set(primary,source); primary.alt=alt||''; if (secondary) window.SHResponsiveCards.set(secondary,secondarySource||source); overlay.remove(); }, prefersReducedMotion()?20:300);
    }

    function readFilterControls() { ['categories','rooms','materials','patterns','moods','prices','availability'].forEach(function (groupName) { state[groupName]=new Set(Array.from(root.querySelectorAll('[data-sh-filter-input="'+groupName+'"]:checked')).map(function (input) { return input.value; })); }); }
    function clearFilterSets() { state.categories.clear(); state.rooms.clear(); state.materials.clear(); state.patterns.clear(); state.moods.clear(); state.prices.clear(); }
    function clearFilters(scroll) {
      state.view='all'; clearFilterSets(); state.availability=new Set(['in-stock']); state.sort='featured'; state.limit=initialLimit;
      if (sortSelect) sortSelect.value='featured'; syncViewButtons(); syncFilterControls(); render(); if (scroll) scrollToFirstProductCard();
    }

    function openDrawer(trigger) { lastFocus=trigger||document.activeElement; syncFilterControls(); updateDraftFilters(); filterDrawer.classList.add('is-open'); filterBackdrop.classList.add('is-open'); filterDrawer.setAttribute('aria-hidden','false'); lockBody(true); window.setTimeout(function () { var focus=filterDrawer.querySelector('input,button'); if (focus) focus.focus(); },120); }
    function closeDrawer() { filterDrawer.classList.remove('is-open'); filterBackdrop.classList.remove('is-open'); filterDrawer.setAttribute('aria-hidden','true'); lockBody(false); if (lastFocus) lastFocus.focus(); }

    function openQuick(handle, groupKey, trigger) {
      activeModalGroup=groups.find(function (group) { return group.key===groupKey; }) || groups.find(function (group) { return group.members.some(function (product) { return product.handle===handle; }); });
      activeModalProduct=products.find(function (product) { return product.handle===handle; });
      if (!activeModalProduct) return;
      lastFocus=trigger||document.activeElement;
      setActiveModalProduct(activeModalProduct);
      modal.classList.add('is-open'); modalBackdrop.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); lockBody(true);
      window.setTimeout(function () { var close=modal.querySelector('[data-sh-close-quick]'); if (close) close.focus(); },120);
    }

    function setActiveModalProduct(product) {
      activeModalProduct=product;
      var preferred=preferredVariantByProduct[product.handle];
      activeVariant=product.variants.find(function (variant) { return String(variant.id)===String(preferred) && variant.available; }) || product.availableVariants.find(function (variant) { return variant.price===product.primaryPrice; }) || product.availableVariants[0] || product.variants[0] || null;
      renderQuickModal();
    }

    function renderQuickModal() {
      if (!activeModalProduct) return; var image=activeVariant&&activeVariant.image?activeVariant.image:activeModalProduct.image;
      var imageNode=modal.querySelector('[data-sh-quick-image]'); imageNode.src=image||''; imageNode.alt=activeModalProduct.imageAlt||activeModalProduct.title;
      modal.querySelector('[data-sh-quick-kicker]').textContent=filterDisplayLabel('categories',activeModalProduct.category)+' · '+filterDisplayLabel('rooms',activeModalProduct.primaryRoom);
      modal.querySelector('[data-sh-quick-title]').textContent=activeModalProduct.title; modal.querySelector('[data-sh-quick-fact]').textContent=activeModalProduct.fact||''; modal.querySelector('[data-sh-quick-link]').href=activeModalProduct.url;
      var familyNode=modal.querySelector('[data-sh-quick-family]'); if (familyNode) familyNode.innerHTML='';
      modal.querySelector('[data-sh-quick-options]').innerHTML=optionControlsMarkup(activeModalProduct,activeVariant); updateModalVariant();
    }

    function switchQuickFamily(handle) {
      if (!activeModalGroup) return;
      var next=activeModalGroup.members.find(function (product) { return product.handle===handle; });
      if (!next || next===activeModalProduct) return;
      preloadProductAssets(next).then(function () { setActiveModalProduct(next); });
    }

    function filterDisplayLabel(groupName,value) {
      var group=filterDefinitions[groupName]||[]; var match=group.find(function (entry) { return entry[0]===value; });
      return match?match[1]:value;
    }

    function impactLabel(value) { return value||''; }

    function optionControlsMarkup(product, variant) {
      if (!product.variants.length || (product.variants.length===1 && product.variants[0].title==='Default Title')) return '';
      var optionMap=new Map();
      product.variants.forEach(function (item) { item.options.forEach(function (option) {
        if (String(option.name).toLowerCase()==='title' && String(option.value).toLowerCase()==='default title') return;
        if (!optionMap.has(option.name)) optionMap.set(option.name,[]);
        if (optionMap.get(option.name).indexOf(option.value)===-1) optionMap.get(option.name).push(option.value);
      }); });
      return Array.from(optionMap.entries()).map(function (entry) {
        var selected=variant&&variant.options.find(function (option) { return option.name===entry[0]; });
        return '<div class="sh-pi__option"><label><span>'+escapeHtml(entry[0])+'</span><span data-sh-option-selected="'+escapeHtml(entry[0])+'">'+escapeHtml(selected?selected.value:entry[1][0])+'</span></label><select data-sh-quick-option="'+escapeHtml(entry[0])+'">'+entry[1].map(function (value) { return '<option value="'+escapeHtml(value)+'"'+(selected&&selected.value===value?' selected':'')+'>'+escapeHtml(value)+'</option>'; }).join('')+'</select></div>';
      }).join('');
    }

    function updateModalVariant() {
      if (!activeModalProduct) return;
      var selections=Object.create(null);
      modal.querySelectorAll('[data-sh-quick-option]').forEach(function (select) { selections[select.dataset.shQuickOption]=select.value; var display=modal.querySelector('[data-sh-option-selected="'+cssEscape(select.dataset.shQuickOption)+'"]'); if (display) display.textContent=select.value; });
      if (Object.keys(selections).length) {
        activeVariant=activeModalProduct.variants.find(function (variant) { return Object.keys(selections).every(function (name) { return variant.options.some(function (option) { return option.name===name && option.value===selections[name]; }); }); }) || null;
      }
      modal.querySelector('[data-sh-quick-price]').innerHTML=priceMarkup(activeModalProduct,activeVariant);
      var addButton=modal.querySelector('[data-sh-modal-add]'); var status=modal.querySelector('[data-sh-quick-status]'); var available=activeVariant&&activeVariant.available;
      addButton.disabled=!available; addButton.textContent=available?copy.addToBag:copy.unavailable;
      status.textContent=available?copy.ready:copy.combinationUnavailable; status.classList.toggle('is-unavailable',!available);
      if (activeVariant&&activeVariant.image) crossfadeQuickImage(activeVariant.image);
    }

    function crossfadeQuickImage(source) {
      var imageNode=modal.querySelector('[data-sh-quick-image]'), container=modal.querySelector('.sh-pi__quick-media');
      if (!imageNode||!container||!source||imageNode.getAttribute('src')===source||imageNode.src===source) return;
      preloadImage(source).then(function () {
        if (!modal.classList.contains('is-open')||!activeVariant||activeVariant.image!==source) return;
        container.querySelectorAll('.sh-pi__quick-transition-image').forEach(function (item) { item.remove(); });
        var overlay=document.createElement('img'); overlay.className='sh-pi__quick-transition-image'; overlay.src=source; overlay.alt=''; overlay.setAttribute('aria-hidden','true'); container.appendChild(overlay);
        window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { overlay.classList.add('is-active'); }); });
        window.setTimeout(function () { imageNode.src=source; overlay.remove(); },prefersReducedMotion()?20:280);
      });
    }

    function closeQuick() { modal.classList.remove('is-open'); modalBackdrop.classList.remove('is-open'); modal.setAttribute('aria-hidden','true'); lockBody(false); activeModalGroup=null; activeModalProduct=null; activeVariant=null; if (lastFocus) lastFocus.focus(); }

    function addActiveVariant(button) {
      if (!activeVariant||!activeVariant.available||button.disabled) return;
      var original=button.textContent; button.disabled=true; button.textContent=copy.adding;
      fetch(root.dataset.cartAddUrl||'/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(activeVariant.id),quantity:1}]})})
        .then(function (response) { return response.json().then(function (payload) { if (!response.ok) throw new Error(payload.description||payload.message||'Unable to add this product.'); return payload; }); })
        .then(function (payload) { return fetch((window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/')+'cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}}).then(function (response) { return response.json(); }).then(function (cart) { return {payload:payload,cart:cart}; }); })
        .then(function (result) {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:result.cart}}));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{source:'textile-architecture',product:activeModalProduct,variant:activeVariant}}));
          closeQuick();
        }).catch(function (error) { var status=modal.querySelector('[data-sh-quick-status]'); status.textContent=error.message||copy.addError; status.classList.add('is-unavailable'); button.disabled=false; button.textContent=original; });
    }

    function toggleSaved(key, button) { if (saved.has(key)) saved.delete(key); else saved.add(key); try { localStorage.setItem(STORAGE_KEY,JSON.stringify(Array.from(saved))); } catch (error) {} button.classList.toggle('is-saved',saved.has(key)); button.setAttribute('aria-pressed',saved.has(key)?'true':'false'); }
    function readSaved() { try { return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY)||'[]')); } catch (error) { return new Set(); } }
    function showToast(message) { toast.textContent=message; toast.classList.add('is-showing'); clearTimeout(showToast.timer); showToast.timer=window.setTimeout(function () { toast.classList.remove('is-showing'); },2300); }

    function requestStickyOffset() { if (stickyFrame) return; stickyFrame=window.requestAnimationFrame(function () { stickyFrame=null; updateStickyOffset(); }); }
    function updateStickyOffset() { var header=document.querySelector('#SiteHeader'); var offset=0; if (header&&header.classList.contains('site-header--stuck')) offset=Math.max(0,Math.round(header.getBoundingClientRect().bottom)); root.style.setProperty('--sh-pi-sticky-top',offset+'px'); }
    function scrollToFirstProductCard() { window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { var first=grid.querySelector('[data-sh-card]'); if (!first) return; var toolbar=root.querySelector('.sh-pi__toolbar-shell'); var style=toolbar?window.getComputedStyle(toolbar):null; var stickyTop=style?parseFloat(style.top)||0:0; var offset=(toolbar?toolbar.offsetHeight:0)+stickyTop+14; window.scrollTo({top:Math.max(0,window.scrollY+first.getBoundingClientRect().top-offset),behavior:prefersReducedMotion()?'auto':'smooth'}); }); }); }
    function lockBody(locked) { document.documentElement.classList.toggle('sh-pi-modal-open',locked); document.body.style.overflow=locked?'hidden':''; }
    function onKeydown(event) { if (event.key!=='Escape') return; if (modal.classList.contains('is-open')) closeQuick(); else if (filterDrawer.classList.contains('is-open')) closeDrawer(); }
    filterBackdrop.addEventListener('click',closeDrawer); modalBackdrop.addEventListener('click',closeQuick);
    function prefersReducedMotion() { return window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    function escapeHtml(value) { return String(value==null?'':value).replace(/[&<>'"]/g,function (character) { return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[character]; }); }
    function cssEscape(value) { if (window.CSS&&typeof window.CSS.escape==='function') return window.CSS.escape(value); return String(value).replace(/(["\\])/g,'\\$1'); }
  }

  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load',function (event) { initAll(event.target); });
}());


